import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import { App } from "../../types/types";
import { StandardButton } from "../../components/StandardButton";

interface ConfirmationDialogsProps {
  gameToStart: App.GameWithCreator | null;
  confirmSignOut: boolean;
  onConfirmStart: () => Promise<void>;
  onCancelStart: () => void;
  onConfirmSignOut: () => Promise<void>;
  onCancelSignOut: () => void;
}

export const ConfirmationDialogs: React.FC<ConfirmationDialogsProps> = ({
  gameToStart,
  confirmSignOut,
  onConfirmStart,
  onCancelStart,
  onConfirmSignOut,
  onCancelSignOut,
}) => {
  return (
    <>
      {/* Confirm Start Game */}
      <Dialog
        open={!!gameToStart}
        PaperProps={{
          sx: {
            borderRadius: 2,
            p: 1,
          },
        }}
      >
        <DialogTitle sx={{ fontWeight: "bold", color: "primary.main" }}>
          Start Game
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to start "{gameToStart?.name}"? Once you
            start, you cannot edit the configuration.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <StandardButton
            variant="outlined"
            color="error"
            onClick={onCancelStart}
          >
            Cancel
          </StandardButton>
          <StandardButton
            variant="contained"
            color="primary"
            onClick={onConfirmStart}
            autoFocus
          >
            Start Game
          </StandardButton>
        </DialogActions>
      </Dialog>

      {/* Confirm Sign Out */}
      <Dialog
        open={confirmSignOut}
        PaperProps={{
          sx: {
            borderRadius: 2,
            p: 1,
          },
        }}
      >
        <DialogTitle sx={{ fontWeight: "bold", color: "primary.main" }}>
          Sign Out
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to sign out?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <StandardButton
            variant="outlined"
            color="error"
            onClick={onCancelSignOut}
          >
            Cancel
          </StandardButton>
          <StandardButton
            variant="contained"
            color="primary"
            onClick={onConfirmSignOut}
            autoFocus
          >
            Yes, Sign Out
          </StandardButton>
        </DialogActions>
      </Dialog>
    </>
  );
};
